/* eslint-disable no-unused-vars */
import React from 'react';
import ReactDOM from 'react-dom';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
// DO NOT REMOVE bootstrap IMPORT. Accordions depend on it!!!
import * as bootstrap from 'bootstrap';
import App from './App';
import Navigation from './BbNavigation';
import './index.css';
import reportWebVitals from './reportWebVitals';
import './bb.css';

ReactDOM.render(
  <React.StrictMode>
    <Container fluid>
      <Row className="g-0 text-center">
        <Col xs={12}>
          <Navigation />
        </Col>
      </Row>

      {/* <Row className="g-0 text-center">
        <Col xs={12}>
          <div id="chatLog" />
        </Col>
      </Row> */}

      <Row className="g-0 text-center">
        <Col xs={12}>
          <App currentAction="welcome" />
        </Col>
      </Row>
    </Container>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
